import { render, staticRenderFns } from "./VideoModulePreview.vue?vue&type=template&id=07be2569&scoped=true"
import script from "./VideoModulePreview.vue?vue&type=script&lang=js"
export * from "./VideoModulePreview.vue?vue&type=script&lang=js"
import style0 from "./VideoModulePreview.vue?vue&type=style&index=0&id=07be2569&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07be2569",
  null
  
)

export default component.exports